import { useI18n, useSettings } from '../../hooks';

const FreeSalePercentText: React.FC = () => {

	const { settings } = useSettings();
	const freeSaleText = useI18n(i18n => i18n.freeSale);

	return (
		<>
			{freeSaleText.saleIsClosed}<br />
			{`${freeSaleText.saleWillBeOpen}${settings?.freeSalePercent}${freeSaleText.ofKits}`}
		</>
	)
};

export default FreeSalePercentText;
